import React from 'react'
import { Card } from '../../ui'
import { InlineManagerNote } from '../annotations/InlineManagerNote.jsx'

/**
 * Generic free-text card for track cards 2/3/4 and forward-look card 1.
 * Renders a tag label, title, textarea, and optional inline manager note.
 */
export function FreeTextCard({
  tag,
  title,
  value = '',
  onChange,
  placeholder = '',
  readOnly = false,
  isClosed = false,
  managerNote = '',
  onManagerNoteChange,
  onSuggestManagerNote,
  isManager = false,
  isReady = false,
  isShared = false,
}) {
  return (
    <Card style={isClosed ? { background: 'var(--locked-bg)' } : undefined}>
      <div style={styles.container}>
        <span style={styles.tag}>{tag}</span>
        <h4 style={styles.title}>{title}</h4>
        <textarea
          style={{
            ...styles.textarea,
            background: 'transparent',
          }}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          placeholder={readOnly ? '' : placeholder}
          disabled={readOnly}
          rows={3}
          aria-label={title}
        />
        <InlineManagerNote
          value={managerNote}
          onChange={onManagerNoteChange}
          onSuggest={onSuggestManagerNote}
          isManager={isManager}
          isReady={isReady}
          isShared={isShared}
          isClosed={isClosed}
        />
      </div>
    </Card>
  )
}

const styles = {
  container: { display: 'flex', flexDirection: 'column', gap: '6px' },
  tag: {
    fontSize: '10px',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: 'var(--text-secondary)',
  },
  title: {
    fontSize: '13px',
    fontWeight: 600,
    color: 'var(--text-primary)',
    margin: 0,
  },
  textarea: {
    width: '100%',
    border: 'none',
    outline: 'none',
    color: 'var(--text-primary)',
    resize: 'vertical',
    lineHeight: 1.6,
    fontSize: '13px',
    fontFamily: 'inherit',
  },
}
